export default __webpack_public_path__ + "static/media/timer.50e0acdf.svg";